import { AbstractFormElement, ICustomFormElement } from "./Abstract";

interface ICheckbox extends ICustomFormElement {
    checked: boolean;
}

class Checkbox extends AbstractFormElement implements ICheckbox {
    protected mainEvent: string = "change";

    protected declare input: HTMLInputElement;

    /**
     * @inheritDoc
     */
    initElements() {
        super.initElements();
        this.input.type = "checkbox";
        if (this.hasAttribute("value")) {
            this.input.value = this.getAttribute("value");
        } else {
            this.input.value = "on";
        }
        return this;
    }

    /**
     * @inheritDoc
     */
    initAttributes() {
        this.checked = this.hasAttribute("checked");
        // @ts-ignore
        this.internals.states[this.checked ? "add" : "delete"]("--checked");
        return super.initAttributes();
    }

    /**
     * add event listeners
     */
    attachEvents() {
        this.label.addEventListener("click", () => {
            this.checked = !this.checked;
            this.validate();
        });
        return super.attachEvents();
    }

    get checked() {
        return this.input.checked;
    }

    set checked(v) {
        this.input.checked = !!v;
        this.inputWrapper.classList.toggle("checked", this.checked);
        // @ts-ignore
        this.internals.states[this.checked ? "add" : "delete"]("--checked");
        this.input.dispatchEvent(new Event("change"));
    }
}

Checkbox.prototype.template = document.createElement("template");

Checkbox.prototype.template.innerHTML = /*html*/ `
<label class="std-fe radio-check">
    <span class="input"></span>
    <span class="icon checkbox keep-svg"></span>
    <span class="icon checkbox keep-svg active"></span>
    <span class="label"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-checkbox", Checkbox);

export { Checkbox };
